import { render, staticRenderFns } from "./SelectNewStatusDialog.vue?vue&type=template&id=4079aad2&"
import script from "./SelectNewStatusDialog.vue?vue&type=script&lang=js&"
export * from "./SelectNewStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectNewStatusDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDialog,VForm,VIcon,VSelect})
